import { render } from "./table.vue?vue&type=template&id=f9d89f16&scoped=true"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"

import "./table.vue?vue&type=style&index=0&id=f9d89f16&lang=css"
import "./table.vue?vue&type=style&index=1&id=f9d89f16&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9d89f16"]])

export default __exports__